module.exports = __webpack_public_path__ + "img/232.855d8523.jpg";